/**
 * Unsere Shops – Karte mit Marken-Filter (OpenStreetMap via Leaflet)
 *
 * Liest die Shop-Daten aus dem eingebetteten JSON-Script (#shops-data-json),
 * baut für jeden Shop einen Leaflet-Marker auf OpenStreetMap-Kacheln und
 * blendet Marker beim Klick auf einen Filter-Button (data-brand) ein/aus.
 * Kein API-Key nötig.
 */

(function () {
  let shopsMap;
  let shopsMarkers = [];
  let shopsData = [];

  function getShopsData() {
    const el = document.getElementById('shops-data-json');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Konnte Shop-Daten nicht parsen:', e);
      return [];
    }
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initShopsMap() {
    const mapEl = document.getElementById('shops-map');
    if (!mapEl || typeof L === 'undefined') return;

    shopsData = getShopsData()
      .map(function (s) {
        return {
          name: s.name,
          address: s.address,
          brands: s.brands,
          lat: typeof s.lat === 'number' ? s.lat : parseFloat(s.lat),
          lng: typeof s.lng === 'number' ? s.lng : parseFloat(s.lng),
        };
      })
      .filter(function (s) {
        return !isNaN(s.lat) && !isNaN(s.lng);
      });

    if (shopsData.length === 0) {
      mapEl.innerHTML = '<p class="shops-map__empty">Noch keine Shops hinterlegt.</p>';
      return;
    }

    shopsMap = L.map(mapEl, {
      scrollWheelZoom: false,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-Mitwirkende',
    }).addTo(shopsMap);

    const bounds = [];

    shopsMarkers = shopsData.map(function (shopItem) {
      const marker = L.marker([shopItem.lat, shopItem.lng]).addTo(shopsMap);

      const gmapsUrl =
        'https://www.google.com/maps/dir/?api=1&destination=' + shopItem.lat + ',' + shopItem.lng;

      const brandsHtml =
        shopItem.brands && shopItem.brands.length
          ? '<div class="shops-map__popup-brands">' + shopItem.brands.map(escapeHtml).join(', ') + '</div>'
          : '';

      const productsHtml =
        shopItem.products && shopItem.products.length
          ? '<div class="shops-map__popup-products"><strong>Verfügbare Parfüms:</strong><br>' +
            shopItem.products.map(escapeHtml).join(', ') +
            '</div>'
          : '';

      marker.bindPopup(
        '<div class="shops-map__infowindow">' +
          '<strong>' + escapeHtml(shopItem.name) + '</strong><br>' +
          escapeHtml(shopItem.address) +
          brandsHtml +
          productsHtml +
          '<a class="shops-map__popup-route" href="' + gmapsUrl + '" target="_blank" rel="noopener">Route planen (Google Maps)</a>' +
          '</div>'
      );

      marker.shopBrands = shopItem.brands || [];
      bounds.push([shopItem.lat, shopItem.lng]);

      return marker;
    });

    if (bounds.length === 1) {
      shopsMap.setView(bounds[0], 13);
    } else {
      shopsMap.fitBounds(bounds, { padding: [40, 40] });
    }

    initShopsFilter();
  }

  function initShopsFilter() {
    const buttons = document.querySelectorAll('.shops-filter__btn');
    const listItems = document.querySelectorAll('.shops-list__item');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');

        const selectedBrand = button.getAttribute('data-brand');
        applyBrandFilter(selectedBrand, listItems);
      });
    });
  }

  function applyBrandFilter(selectedBrand, listItems) {
    shopsMarkers.forEach(function (marker) {
      const matches = selectedBrand === 'all' || marker.shopBrands.indexOf(selectedBrand) !== -1;
      if (matches) {
        if (!shopsMap.hasLayer(marker)) marker.addTo(shopsMap);
      } else {
        shopsMap.removeLayer(marker);
      }
    });

    listItems.forEach(function (item) {
      const brands = (item.getAttribute('data-brands') || '').split('|');
      const matches = selectedBrand === 'all' || brands.indexOf(selectedBrand) !== -1;
      item.style.display = matches ? '' : 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopsMap);
  } else {
    initShopsMap();
  }
})();
